import { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useUserActions } from "../../hooks/user.actions";
import { GoogleLoginButton, AppleLoginButton } from "react-social-login-buttons";
import { Link } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from 'react-facebook-login';


function LoginForm() {
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);
    const [form, setForm] = useState({});
    const [error, setError] = useState(null);
    const userActions = useUserActions();

    const handleGoogleLogin = useGoogleLogin({
        scope: 'openid profile email',
        flow: 'implicit', // optional, defaults to 'implicit'
        onSuccess: async (tokenResponse) => {
            try {
                userActions.loginWithSocial('google', { access_token: tokenResponse.access_token });
            } catch (err) {
                console.error('Login failed:', err.response?.data || err.message);
            }
        },
        onError: (errorResponse) => {
            console.error('Google login error:', errorResponse);
        },
    });



    const handleSubmit = (event) => {
        event.preventDefault();
        const loginForm = event.currentTarget;

        if (loginForm.checkValidity() === false) {
            event.stopPropagation();
        }

        setValidated(true);

        const data = {
            email: form.email,
            password: form.password,
        };

        userActions.login(data).then(() => navigate("/")).catch((err) => {
            if (err.message) {
                setError(err.request.response);
            }
        });
    };

    const responseFacebook = (response) => {
        console.log(response);
        try {
            userActions.loginWithSocial('facebook', { access_token: response.accessToken });
        } catch (err) {
            console.error('Login failed:', err.response?.data || err.message);
        }
    }

    const componentClicked = (response) => {
        console.log(response);
    }

    return (
        <div className="container-fluid">
            <Form
                id="login-form"
                className="border p-4 rounded col-auto"
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
                data-testid="login-form"
            >
                <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        value={form.email}
                        data-testid="username-field"
                        onChange={(e) => setForm({ ...form, email: e.target.value })}
                        required
                        type="text"
                        placeholder="Enter email"
                    />
                    <Form.Control.Feedback type="invalid">
                        This file is required.
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        value={form.password}
                        data-testid="password-field"
                        minLength="8"
                        onChange={(e) => setForm({ ...form, password: e.target.value })}
                        required
                        type="password"
                        placeholder="Password"
                    />
                    <Form.Control.Feedback type="invalid">
                        Please provide a valid password.
                    </Form.Control.Feedback>
                </Form.Group>

                <div className="text-content text-danger">{error && <p>{error}</p>}</div>
                <Row>
                    <Col>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Col>
                </Row>
                <div>
                    <p className="dflex mt-4">
                        New to SEOLI please{" "}
                        <Link to="/register/">register</Link>.
                    </p>
                </div>
                <hr />
                <div className="d-flex flex-column align-items-center mb-0 mt-0">
                    <GoogleLoginButton className="mb-3" onClick={handleGoogleLogin} data-testid="google-login-button" />
                    <FacebookLogin
                        appId={process.env.REACT_APP_FACEBOOK_APP_ID}
                        autoLoad={false}
                        fields="name,email,picture"
                        scope="public_profile"
                        icon="fa-facebook"
                        callback={responseFacebook}
                        onClick={componentClicked}
                        cssClass="mb-3 facebook-login-button"
                        containerStyle={{
                            display: 'block',
                            width: 'calc(100% - 10px)'
                        }}
                        buttonStyle={{
                            textAlign: 'left',
                        }}
                        data-testid="facebook-login-button"
                    />
                    <AppleLoginButton className="mb-3" />
                </div>
            </Form>
        </div>
    );
}

export default LoginForm;